const formatPageTitle = (title: string): string => `${title} | Agent Portal`;

export default formatPageTitle;
